export default {
  exhibition: {
    filterTitle: '類別篩選',
    companyTypeTitle: '公司類型',
    searchPlaceholder: '搜索產品',
    filterButton: '篩選',
    clearAll: '清空全部',
    categories: {
      literature: '文學、小說',
      humanities: '人文史地',
      socialScience: '社會科學',
      naturalScience: '自然科普',
      business: '商管理財',
      art: '藝術設計',
      selfHelp: '心靈勵志',
      lifestyle: '實用生活',
      children: '兒童及青少年讀物',
      language: '語言學習',
      comics: '繪本、漫畫',
      exam: '考試用書',
      digital: '電子書和有聲書',
      promotional: '宣傳品',
      stationery: '文儀用品',
      others: '其他（請列明）'
    },
    title: '展區信息',
    location: '位置',
    time: '時間',
    description: '簡介',
    exhibits: '展品',
    activities: '活動'
  },
  detail: {
    companyName: '公司名稱',
    companyIntro: '公司介紹',
    companyType: '公司種類',
    contact: '聯絡',
    contactPerson: '公司商務/版權聯絡人姓名',
    position: '職位',
    email: '電郵',
    phone: '電話',
    fax: '傳真',
    address: '通訊地址',
    website: '網頁',
    moreProducts: '更多展品推薦',
    companyTypes: {
      publishing: '出版',
      printing: '印刷'
    }
  },
  footer: {
    copyright: '© 2025 香港書展 版權所有',
    disclaimer: '免責聲明：在本刊物/活動内(或由項目小組成員)表達的任何意見、研究成果、結論或建議，均不代表香港特別行政區政府、文化體育及旅遊局、文創產業發展處 、 “創意智優計劃”秘書處或“創意智優計劃”審核委員會的觀點。'
  },
  nav: {
    home: '香港館',
    exhibition: '展區',
    exhibits: '展品',
    exhibitors: '參展商名錄',
    sponsors: '聯絡我們',
    comprehensive: '綜合展區',
    award: '得獎作品展區',
    pictureBook: '繪本專區',
    creative: '創意區',
    heritage: '“漫步香港：非遺與城市記憶”區',
    organiser: '主辦機構 ',
    CoOrganizers: '共同承辦',
    Sponsors: '贊助機構',
    supportingOrganizers: '支持機構',
    themeExhibition: '主題展區：',
    ranking: '（排名不分先後）：',
    publications: '「漫步香港：非遺與城市記憶」',
    printing: '香港插畫專區',
    artInstallationsAndCrafts: '香港作家掠影展區',
    officialWebsite: '香港館官網',
    publicationsDesc: `是次香港館特設主題展區，聚焦展示七項香港非物質文化遺產，呈現本地匠人對傳統工藝的堅持與創新精神，體現優秀中華文化在香港的傳承與創新。 展品涵蓋“蒸籠製作技藝”、“花鈕製作技藝”、“廣彩製作技藝”、“粵劇頭飾製作”、“紮作技藝”、“港式奶茶製作技藝”及“舞火龍”，涵蓋香港傳統手工藝與節慶民俗。觀眾可近距離欣賞以竹編成的點心蒸籠、精巧細緻的長衫花鈕、色彩斑斕的手繪廣彩瓷器，以及閃爍耀目的粵劇頭飾；亦可瞭解“舞火龍”的社區傳統及背後儀式意涵，感受港式奶茶在日常飲食文化中的深厚底蘊。主題展區內亦展出相關圖書及印刷品。`,
    printingDesc: `是次香港館繼續設有“香港插畫專區”，展示入選第二屆“《飛躍繪本》——香港繪本插畫師國際書展推廣計劃”的八位香港新晉繪本插畫師的作品，以及八本在“香港繪本出版支援計劃”下出版的無字繪本。兩項計劃均由創意創業會主辦、文化創意產業發展處資助。`,
    artInstallationsAndCraftsDesc: `是次香港館特設“香港作家掠影展區”，展出逾70種由香港出版社出品的華語文學作品，包括：榮獲第4屆香港出版雙年獎出版大獎及最佳出版獎（文學及小說類）由西西著作、何福仁主編的《動物嘉年華：西西的動物詩（中英雙語版本）》；以及展出與香港有着頗深淵源的四位華語作家：葉靈鳳、張愛玲、劉以鬯、西西，他們的30多件珍貴的手稿複製品和相關圖片。\n\n此展區亦是為2025年10月在香港舉辦的首屆“世界華語文學節”預熱宣傳。“世界華語文學節”希望打造全球華語文學的核心交流平台，推動香港成為世界華語文學之都，助力香港鞏固發展中外文化藝術交流中心。`,
    all: '全部',
  },
  message: {
    noData: '暫無數據',
    contactUs: '聯絡我們',
    ProductDescription: '產品資訊',
    category: '類別',
    author: '作者',
    publishDate: '出版日期/印刷日期',
    type: '種類'
  },
  common: {
    loading: '加載中...',
    noData: '暫無數據',
    error: '出錯了',
    retry: '重試'
  },
  home: {
    title: '2025年北京國際圖書博覽會香港館',
    description: '香港特別行政區(香港特區)政府文創產業發展處於2025年6月18至22日首次主辦北京國際圖書博覽會香港館，以推廣香港作為中外文化藝術交流中心，以及協助香港出版及印刷業開拓內地市場。項目由香港出版總會與香港印刷業商會共同承辦，並獲香港特區政府駐北京辦事處、創意創業會、世界華語文學基金會、香港專業人員(北京)協會，以及香港印刷業商會屬下的印刷科技研究中心擔任支持機構。',
    description2: '是次香港館的主題為“漫步香港：非遺與城市記憶”，在主題展區著重展現香港非物質文化遺產與城市記憶在交互輝映下，體現“以文塑旅，以旅彰文”，推動文化和旅遊融合發展。',
    description3: '“北京國際圖書博覽會”作為國內最大及國際第二大的書展，對推動版權貿易有著舉足輕重的角色。為協助香港出版及印刷業界進一步通過“北京國際圖書博覽會”，推廣優秀的香港圖書、印刷品及電子書，同時為配合香港特區政府公布的“文藝創意產業發展藍圖”，利用香港國際化的策展和創作技巧，推廣中華傳統優秀文化和香港獨特文化，以及推動非物質文化遺產(非遺)的傳承和轉化創新，自2011年起已在“北京國際圖書博覽會”設立的“香港館”將進行革新，除了改由文創產業發展處主辦、香港出版總會承辦外，計劃邀請非物質遺產辦公室、香港旅遊業議會、文化葫蘆等協辦，更會加強“香港館”的內容，設立特定主題以展示優秀的香港出版物、印刷品及相關展品，同時利用此平台，將香港獨特文化展現給來自全國及世界各地的參展商及參觀者，以進一步鞏固香港作為“中外文化藝術交流中心”的地位。',
    viewMore: '進入香港館'
  },
  ablout: {
    title1: '文創產業發展處',
    title2: '香港出版總會',
    title3: '香港印刷業商會',
    website: '網址',
    phone: '電話',
    email: '電郵',
    address: '地址',
    address1: '香港灣仔告士打道5號稅務大樓四十樓',
    address2: '香港北角英皇道75-83號聯合出版大廈26樓',
    address3: '香港灣仔莊士敦道48-50號二樓'
  }
}
